export default {
  header: 'API kľúče',
  subheader: 'API kľúče sa používajú na programový prístup k Qmulus API.\nKaždý kľúč automaticky dedí oprávnenia používateľa a koná v jeho mene',
  qmulusApiUrl: 'URL adresa Qmulus API',
  openApiSpecification: 'Špecifikácia OpenAPI',
  openApiExplorer: 'Otvoriť prieskumník API',
  noApiAccess: 'Na vytváranie a úpravu kľúčov API je potrebný prístup k API. Požiadajte správcu, aby vám ho udelil.',
};
